export default "__VITE_ASSET__aWuExxUt__"